export default {"src":"/_next/static/media/data_integration_preparation.c94eaa31.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};